import findAliasAttributes from "./utils/find-alias-attributes";
import replaceAliases from "./utils/replace-aliases";
import replaceOriginalAttributes from "./utils/replace-original-attributes";

/**
 * Find and process aliases
 * @param {Array<String>} input
 * @returns {Array<String>}
 */
const processAliases = (input) => {
  /** Find attributes that includes an alias */
  const matches = findAliasAttributes(input);

  /** Replace attributes with aliases */
  const replaced = replaceAliases(matches);

  /** Final, returned array with replaced aliases */
  return replaceOriginalAttributes(input, replaced);
};

export default processAliases;
